import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_APPROVALPERSONS } from "../../../../utils/constants";
import { ApprovalPersonInterface } from "../../../../models/ProcurementModule/ApprovalPerson";
import approvalPersonService from "../../../../services/procurementService/approvalPersonService";

const useApprovalPersons = (page: number, pageSize: number) =>
  useQuery<ApprovalPersonInterface[], Error>({
    queryKey: [CACHE_KEY_APPROVALPERSONS, page, pageSize],
    queryFn: () => approvalPersonService.GetAll(page, pageSize),
    initialData: [],
  });

export default useApprovalPersons;
